import { createSlice } from '@reduxjs/toolkit'

const tableUISlice = createSlice({
    name: 'tableUI',
    initialState: { highlightedRstChainId: null, highlightedNodeId: null, tableId: null },
    reducers: {
        setHighlighting: (state, action) => {
            const { nodeId, rstChainId, tableId } = action.payload
            state.highlightedNodeId = nodeId;
            state.highlightedRstChainId = rstChainId;
            state.tableId = tableId;
        },
        removeHighlighting: (state, action) => {
            const { nodeId, rstChainId, tableId } = action.payload
            const { highlightedNodeId, highlightedRstChainId } = state

            if (state.tableId === tableId) {
                if (nodeId === highlightedNodeId) {
                    state.highlightedNodeId = null;
                }
                if (rstChainId === highlightedRstChainId) {
                    state.highlightedRstChainId = null;
                }
            }
        },
    }
})

export const { setHighlighting, removeHighlighting } = tableUISlice.actions;
export default tableUISlice.reducer;